'use client';
import React from 'react';
import { ProductVariation } from '@typings/product';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import Product from '@models/product';
import ProductCollectionList from '@repo/ui/src/components/ProductCollectionList';
import GrillCard from './_GrillCard';

interface Props {
  sizes: Array<ProductVariation>;
  activeProduct: Product;
  dark?: boolean;
}

const AlternateSizes = ({ sizes, activeProduct, dark = false }: Props) => {
  const { t } = useTranslation();

  return (
    <ProductCollectionList
      items={sizes}
      activeId={activeProduct.id}
      itemsLabel={t('productDetailPageContent.sizesAvailableText', undefined, {
        default: 'sizes available',
      })}
      renderItem={(variation, selected) => (
        <GrillCard variation={variation} selected={selected} dark={dark} />
      )}
    />
  );
};

export default AlternateSizes;
